module.exports = __webpack_public_path__ + "static/OCEAN-dc3338ce723508d7c132a23c86b78e86.svg";